import { cacheService } from '../CacheService';
import { clientTokenCache } from './ClientTokenCache';
import { authFetch } from './authFetch';

class DSPTokenService {
  constructor(options = {}) {
    // No hardcoded fallback domain: fall back to the resolver (which throws if
    // the DSP base URL is unconfigured) only when no explicit override is given.
    this.baseUrl = options.baseUrl || cacheService.getApiUrl();
  }

  async getDotstudioToken() {
    return cacheService.getAppData()?.app_data?.token;
  }

  async getClientToken() {
    return clientTokenCache.getClientToken();
  }

  async getAuthHeaders(requireClientToken = false) {
    const dotstudioToken = await this.getDotstudioToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(dotstudioToken ? { 'x-access-token': dotstudioToken } : {}),
    };

    if (requireClientToken) {
      const clientToken = await this.getClientToken();
      return {
        ...headers,
        ...(clientToken ? { 'x-client-token': clientToken } : {}),
      };
    }

    return headers;
  }

  async makeAuthenticatedRequest(endpoint, options = {}, requireClientToken = false) {
    const headers = await this.getAuthHeaders(requireClientToken);
    const url = endpoint.startsWith('http') ? endpoint : `${this.baseUrl}${endpoint}`;

    const response = await authFetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        ...headers,
        ...(options.headers || {}),
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  clearTokens() {
    clientTokenCache.invalidate();
  }
}

const dspTokenService = new DSPTokenService();

export default DSPTokenService;
export { dspTokenService };
